export default function leftpad(string, desiredLength, paddingChar = "0") {
	string = string.toString();

	while (string.length < desiredLength) {
		string = paddingChar + string;
	}

	return string;
}



// WEBPACK FOOTER //
// ./src/utils/left-pad.js